module.exports = __webpack_public_path__ + "static/media/head.e3a9ccfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/playground/components/face/img/faces/ym/head.png
// module id = 395
// module chunks = 0